import { MccMappingsPage as MccMappingsPageView } from "@/components/MccMappingsPage";

export function MccMappingsPage() {
  return <MccMappingsPageView />;
}
